var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    viewBox: "0 0 60 60",
    overflow: "visible"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5,31.5h-57C0.7,31.5,0,30.8,0,30s0.7-1.5,1.5-1.5h57c0.8,0,1.5,0.7,1.5,1.5S59.3,31.5,58.5,31.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30,60c-0.8,0-1.5-0.7-1.5-1.5v-57C28.5,0.7,29.2,0,30,0s1.5,0.7,1.5,1.5v57C31.5,59.3,30.8,60,30,60z"
  })));
};
export default SvgPlus;